import LazyWidgetController from "./lazy_widget_controller"

// Stimulus controller wrapping Toast UI Viewer for .markdown-viewer elements.
//
// Lifecycle (lazy import + Turbo-cache-safe teardown) is handled by
// LazyWidgetController; this subclass supplies load()/build()/destroy().
//
// Behaviour: source comes from data-markdown, falling back to the element's text.
//
// Height defaults to 600px — right for a viewer sitting in a form or a detail
// card, wrong for a full page of prose, which gets an inner scrollbar and is cut
// off. Pass data-markdown-viewer-height-value="auto" (or any CSS length) to
// override; the /admin/help articles do.
//
// Usage in views (rendered by the markdown() helper):
//   <div data-controller="markdown-viewer" class="markdown-viewer"
//        data-markdown="# Hello"></div>
//
export default class extends LazyWidgetController {
  static values = { height: { type: String, default: "600px" } }

  async load() {
    return (await import("@toast-ui/editor/dist/toastui-editor-viewer")).default
  }

  build(Viewer) {
    const el = this.element
    const source = el.dataset.markdown || el.textContent

    return new Viewer({
      el: el,
      height: this.heightValue,
      initialValue: source,
      usageStatistics: false,
    })
  }

  destroy(viewer) {
    // Toast UI Viewer supports destroy(); guard in case a build lacks it.
    if (typeof viewer.destroy === 'function') viewer.destroy()
  }
}
